<div class="container has-own-sub-chrome" loading-spin [isLoading]="isPageLoading" [loadingSize]="'big'"
    [loadingLevel]="110">
    <calendar-sub-chrome [config]="calendarSubChromeConfig"></calendar-sub-chrome>
    <calendar-screen [config]="calendarScreenConfig"></calendar-screen>
</div>